module.exports = __webpack_public_path__ + "img/wdb.36fe6a23.svg";